import changeFileName from '@picsart/cloud-storage/api/changeFileName';

import { ErrorMessages } from '@/consts/errors';
import { getCloudStorageHeaders, withCloudStorageErrorHandling } from './utils';

type Params = {
  id: string;
  name: string;
};

const changeDriveFileName = async ({ id, name }: Params) => {
  return withCloudStorageErrorHandling(async () => {
    await changeFileName({
      id,
      name,
      headers: getCloudStorageHeaders(),
    });
    return true;
  }, ErrorMessages.changeFileName);
};

export { changeDriveFileName };
